import React, { BaseSyntheticEvent } from 'react'
import { Box, TextareaAutosize, Typography } from '@mui/material'
import { ErrorMessage, FormikValues, useFormikContext } from 'formik';

import InputField from '../../../../common/Form/Input/InputField'
import FileUploadButton from '../../../../common/Form/FileUpload/FileUploadButton';
import { useParams } from 'react-router-dom';
import { DATE_OF_RESIGNATION, EMAIL, PASSWORD, REASON_FOR_RESIGNATION, RESIGN_LETTER } from '../../../../../constants/forms';


const TermsOfResignation = () => {
    const { values, setFieldValue } = useFormikContext<FormikValues>();
    const {id} = useParams()

    const inputHandler = (e: BaseSyntheticEvent) => {
        setFieldValue(e.target.name, e.target.value);
    }

    return (
        <>
            <InputField label={"6.1  Date of Resignation"} subtitle="if applicable" name={DATE_OF_RESIGNATION} placeholder={"Date of Resignation"} type="date" />
            <Box className="mg-b-50">
                <label className="form-label mg-b-20">6.2  Reason for resignation <Typography variant={"subtitle1"} component={"span"} color={"secondary"}>(if applicable)</Typography></label>
                <TextareaAutosize
                    name={REASON_FOR_RESIGNATION}
                    value={values[REASON_FOR_RESIGNATION]}
                    onChange={inputHandler}
                    aria-label="minimum height"
                    minRows={3}
                    placeholder="Write the reason..."
                    className="form-control"
                />
                <ErrorMessage name={REASON_FOR_RESIGNATION} render={msg => <span className="text-danger font-size-sm">{msg}</span>} />
                <FileUploadButton name={RESIGN_LETTER} label="Upload Resignation Letter" />
            </Box>
            {
                !id ? <>
            <InputField label={"6.3 Email"} autoComplete="new-email" id="ecmloginemail" name={EMAIL} placeholder={"Write EC member email"} />

            <InputField label={"6.4 Password"} autoComplete="new-pass" id="ecmloginpass" name={PASSWORD} type="password" placeholder={"Write a password"} />
                </> : <></>
            }

        </>
    )
}

export default TermsOfResignation